<template>
  <div>
    <sv-header :asset="asset" title="Nieuws" subtitle="Regelmatige updates via Facebook"></sv-header>
    <v-container>
      <!-- <sv-page-title title="Bekijk de facebook pagina"></sv-page-title> -->
      <v-layout align-center justify-center row>
        <iframe
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsanavitasportmassage%2F&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1057204207786504"
          width="340"
          height="500"
          style="border:none;overflow:hidden"
          scrolling="no"
          frameborder="0"
          allowtransparency="true"
          allow="encrypted-media"
        ></iframe>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    asset() {
      return require("@/assets/sv/headers/nieuws.jpg");
    }
  }
};
</script>

<style lang="scss">
</style>
